__webpack_require__.p = "https://static.milanote.com/";